export default {
  byActionType: {
    score (event) {
      this.setScore(event)

      const progressionTemp = [ ...this.getIngameData.scoreProgression ]

      progressionTemp.push({ home: event.extra['points-1'], away: event.extra['points-2'] })

      this.setIngameProperty({
        property: 'scoreProgression',
        value: progressionTemp
      })
    }
  },
  byEventType: {
    'FINISH_GAME_PREMATURELY' ({ eventInfo: { title } }) {
      this.setPrematurelyGameFinish(title)
    }
  },
  eventTitles: {
    'ADJUST_POINTS' (event) {
      return this.$t('trader.adjust.points.title')
    },
    'CANCEL' (event, relatedEvent) {
      const { homeTeamTitle, awayTeamTitle } = this
      const { eventInfo } = event
      const { title } = eventInfo
      const { EventCode, extra, TeamNumber } = relatedEvent
      const { team } = extra
      const notPointEvents = ['TIMEOUT', 'BALL_IN_GAME', 'FINISH_PERIOD']

      if (notPointEvents.includes(EventCode)) {
        return `${title}: ${this.getEventTitle(relatedEvent)}`
      }

      if (EventCode === 'POINT') {
        return `
          ${title}: 
          ${relatedEvent.eventInfo.title}, 
          ${extra[`points-${team}`]}, 
          ${TeamNumber === 1 ? homeTeamTitle : awayTeamTitle}
        `
      }

      return `${title}: ${this.getEventTitle(relatedEvent)}`
    }
  }
}
